import { pxToRem } from '../../../../utils';
export var embedVariables = function embedVariables(siteVariables) {
  return {
    controlColor: siteVariables.colors.white,
    controlBackgroundColor: siteVariables.colors.onyx[900],
    controlBackgroundSize: pxToRem(24) + " " + pxToRem(24),
    width: undefined,
    height: undefined,
    focusBorderColor: siteVariables.colors.brand[500],
    zIndex: siteVariables.zIndexes.foreground
  };
};
//# sourceMappingURL=embedVariables.js.map
